export const imageBaseUrl = '/atoms/baseModels'
import { I18NText, Model } from 'src/types'
export const glovePriceTaxIncluded = 71500 // 税込
export const softGloveBasePrice = 49500 // 税込
export const softMittBasePrice = 50600 // 税込

const imageWidth = 240
const imageHeight = 180
export const atomsUsBaseModels = (t: I18NText): Model[] => {
  return [
    {
      productNumber: 'AJK-01',
      position: 'pitcher',
      imageUrl: `${imageBaseUrl}/us/usPitcher.jpg`,
      dominantArm: 'both',
      size: t.US_PITCHER.size, //
      webParts: 'w5', // 仮あて
      description: t.US_PITCHER.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'usBackStyle',
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight
    },
    {
      productNumber: 'AJK-05',
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/us/ajk05.jpg`,
      dominantArm: 'both',
      size: t.US_INFIELDER.size,
      webParts: 'w6', // 仮あて
      description: t.US_INFIELDER.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      backStyle: 'usBackStyle',
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight
    },
    {
      productNumber: 'AJK-06',
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/us/usInfielder.jpg`,
      dominantArm: 'both',
      size: 11.5, // inch
      webParts: 'w6', // 仮あて
      description: t.US_INFIELDER.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'usBackStyle',
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight
    },
    {
      productNumber: 'AJK-07',
      position: 'outfielder',
      imageUrl: `${imageBaseUrl}/us/usOutfielder.jpg`,
      dominantArm: 'both',
      size: t.US_OUTFIELDER.size, //
      webParts: 'w21', // 仮あて
      description: t.US_OUTFIELDER.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'usBackStyle',
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight
    }
  ]
}

export const AJK_01 = 'AJK-01'
const AJK_05 = 'AJK-05'
const AJK_06 = 'AJK-06'
const AJK_07 = 'AJK-07'
export const usModelProductNumbers = [AJK_01, AJK_05, AJK_06, AJK_07]

export const mockPitcherModel = (t: I18NText): Model[] => [
  {
    productNumber: 'AKG-1',
    position: 'pitcher',
    imageUrl: `${imageBaseUrl}/akg-1.jpg`,
    dominantArm: 'both',
    size: t.AKG_1.size,
    webParts: 'w1',
    description: t.AKG_1.description,
    series: '',
    isFingerCrotch: false,
    isUBack: false,
    softPrice: softGloveBasePrice,
    price: t.BASE_PRICE_GLOVE,
    brand: 'atoms',
    imageWidth,
    imageHeight
  }
]
